var jCube = require('./core'),
    dataCache = require('./data/dataCache');

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    rmultiDash = /[A-Z]/g;

// function getData( data ) {
//     if ( data === "true" ) {
//         return true;
//     }

//     if ( data === "false" ) {
//         return false;
//     }

//     if ( data === "null" ) {
//         return null;
//     }

//     // Only convert to a number if it doesn't change the string
//     if ( data === +data + "" ) {
//         return +data;
//     }

//     if ( rbrace.test( data ) ) {
//         return JSON.parse( data );
//     }

//     return data;
// }

function dataAttr( elem, key, data ) {
    var name;

    // If nothing was found internally, try to fetch any
    // data from the HTML5 data-* attribute
    if ( data === undefined && elem.nodeType === 1 ) {
        name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
        data = elem.getAttribute( name );

        if ( typeof data === "string" ) {
            try {
                data = getData( data );
            } catch ( e ) {}

            // Make sure we set the data so it isn't changed later
            dataCache.set( elem, key, data );
        } else {
            data = undefined;
        }
    }
    return data;
}

jCube.hasData = function( elem ) {
    return dataCache.hasData( elem ) || dataPriv.hasData( elem );
};

jCube.data = function( elem, name, data ) {
    return dataCache.access( elem, name, data );
};

jCube.removeData = function( elem, name ) {
    dataCache.remove( elem, name );
};

    // TODO: Now that all calls to _data and _removeData have been replaced
    // with direct calls to dataPriv methods, these can be deprecated.
    // _data: function( elem, name, data ) {
    //     return dataPriv.access( elem, name, data );
    // },

    // _removeData: function( elem, name ) {
    //     dataPriv.remove( elem, name );
    // }
// } );


jCube.fn.data = function( key, value ) {
    var i, name, data,
        elem = this[ 0 ],
        attrs = elem && elem.attributes;

    // Gets all values
    if ( key === undefined ) {
        if ( this.length ) {
            data = dataCache.get( elem );

            if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
                i = attrs.length;
                while ( i-- ) {

                    // Support: IE 11+
                    // The attrs elements can be null (#14894)
                    if ( attrs[ i ] ) {
                        name = attrs[ i ].name;
                        if ( name.indexOf( "data-" ) === 0 ) {
                            name = camelCase( name.slice( 5 ) );
                            dataAttr( elem, name, data[ name ] );
                        }
                    }
                }
                dataPriv.set( elem, "hasDataAttrs", true );
            }
        }

        return data;
    }

    // Sets multiple values
    if ( typeof key === "object" ) {
        return this.each( function() {
            dataCache.set( this, key );
        } );
    }

    if ( elem && value === undefined ) {
        data = dataCache.get( elem, key );
        if ( data !== undefined ) {
            return data;
        }

        data = dataAttr( elem, key );
        if ( data !== undefined ) {
            return data;
        }

        return;
    }

    // Set the data...
    this.each( function() {
        dataCache.set( this, key, value );
    });

    return this;
};

jCube.fn.removeData = function( key ) {
    return this.each( function() {
        dataCache.remove( this, key );
    } );
};


// jCube.fn.data = function(name, value) {
//     var _this = this;

//     if (!name) {
//         if (!this[0]) return;
//         var datas_1 = {};
//         each(this[0].attributes, function (i, attr) {
//             var match = attr.name.match(vars.dataAttributeRe);
//             if (!match) return;
//             datas_1[match[1]] = _this.data(match[1]);
//         });
//         return datas_1;
//     }

//     if (jCube.isString(name)) {
//         if (value === undefined) return this[0] && jCube.getData(this[0], name);
//         return this.each(function (i, ele) {
//             return jCube.setData(ele, name, value);
//         });
//     }

//     for (var key in name) {
//         this.data(key, name[key]);
//     }

//     return this;
// };